import { Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SupppliesEntities from "../../components/SuppliesEntities/SuppliesEntities";
import LastBills from "../../components/LastBills/LastBills";
import DynamicPromoBanner from "../../components/UI/DynamicPromoBanner/DynamicPromoBanner";
import StaticPromoBanner from "../../components/UI/StaticPromoBanner/StaticPromoBanner";
import useOwnerData from "../../core/hooks/data/useOwnerData";

const HomePage = () => {
  // Translation
  const { t } = useTranslation();

  useOwnerData();

  return (
    <>
      <Container sx={{ paddingTop: { xs: 5, md: 10 } }}>
        <DynamicPromoBanner text="Contrata Autoconsumo" btnText="Contratar" />
        <Typography variant="h1" component="h1">
          {t("Título Homepage")}
        </Typography>
        <SupppliesEntities />
        <LastBills seeAllButtonText="Ver todas las facturas" />
        <Typography
          component="h3"
          variant="h3"
          paddingBottom={{ xs: "1.5rem", md: "2rem" }}
        >
          {t("Promo.Contrata")}
        </Typography>
        <Stack
          direction={{ xs: "column", md: "row" }}
          gap="1.25rem"
          paddingBottom={{ xs: "56px", md: "80px" }}
        >
          <StaticPromoBanner
            linkurl="https://www.totalenergies.es/es/pymes/autoconsumo-solar"
            btnText="Contratar"
            text="Contrata Autoconsumo"
          />
          <StaticPromoBanner
            linkurl="https://www.totalenergies.es/es/pymes/cargadores-coche-electrico"
            btnText="Contratar"
            text="Contrata Punto de recarga de vehículo eléctrico"
            secondary
          />
        </Stack>
      </Container>
    </>
  );
};

export default HomePage;
